import React, { useEffect, useCallback } from "react";
import { FileItem } from "../../../models/polymer/Document.model";
import { DocumentCrossSvg } from "../../../assets/svg";
import { useUploadingFile } from "../../../hooks/use-uploading-file";
import ImageIcon from "../../../assets/svg/image";
import PdfIcon from "../../../assets/svg/pdf";
import { UploadFileType } from "../../../models/enum/upload-file-type.enum";
import { downloadFile } from "../../../utils/download-file";
import { useAppSelector } from "../../../redux/hook";
interface FileUploadingButtonProps {
  file: FileItem;
  id: string;
  clearFileChange: () => void;
  assignFileFields?: (file_id: string, submitted_date: string, key: string, id:string)=>void;
  assignError?: (isError: boolean, id: string) => void;
  getToDeleteItemModal?: (value: boolean) => void;
  getFileName?: (value: string) => void;
  getFileId?: (value: string) => void;
  type: UploadFileType;
  folderName?: string;
}

function FileUploadingButton({getToDeleteItemModal, getFileName, getFileId, type, folderName = "", ...props}:FileUploadingButtonProps) {
  
  
  const { key, submittedDate, progress, fileId, hasUploaded, setCompleted } = useUploadingFile(props.file, type, folderName);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  useEffect(() => {
    if (props.file?.file_content.file_name) {
      getFileName?.(props.file?.file_content.file_name);
    }
  }, [getFileName, props.file]);

  useEffect(() => {
    if (hasUploaded && fileId && key && submittedDate?.length > 0) {
      props.assignFileFields?.(fileId.toString(), submittedDate, key, props.id);
      setCompleted();
    }
  }, [key, submittedDate, fileId, hasUploaded, props, props.id, setCompleted]);

  const deleteFile = () => {
    getToDeleteItemModal?.(true);
    getFileId?.(props.file.file_content.id);
  };

  useEffect(() => {
      if(progress === -1){
          props.assignError?.(true, props.id);
      }
  }, [progress])

  const handleFileOnClick = useCallback((file?: FileItem) => () =>{
    if(file?.file){
      const url = URL.createObjectURL(file?.file);
      setTimeout(() => window.open(url,"_blank"))
    } else if(file?.key){
      downloadFile(file?.key, singpassToken);
    }
  }, [])

  return (
    <>
      <div className='polymer-file-selection-segment__file-container'>
        {/* <div><FilterLeftSvg/></div> */}
        <div className='polymer-file-selection-segment__file-container__svg-container'>{props.file?.file_content.file_name?.split(".").pop()?.toLocaleLowerCase() === "png" || props.file?.file_content.file_name?.split(".").pop()?.toLocaleLowerCase() === "jpg" ? <ImageIcon /> : <PdfIcon />}</div>
        <div style={{flex:1, cursor: "pointer"}} onClick={handleFileOnClick(props.file)}>
          <p className='m-0'>{props.file?.file_content.file_name} {!hasUploaded && progress !== -1 && <span>{Math.floor(progress).toFixed(0)}%</span>}</p>
        </div>
        <div onClick={deleteFile}>
          <DocumentCrossSvg/>
        </div>
      </div>
    </>
  )
  
}

export default React.memo(FileUploadingButton)